import React, {useState,  useEffect, useMemo, useCallback} from 'react';
import {VisDiv } from '..';
import { sortByOrder, sortByArrayElement, errorAlert, htmlInfoLine  } from '../../lib/utils'; 
import {  IoIosEye, IoIosEyeOff, IoMdCart } from 'react-icons/io';
import {FiEdit, FiSave, FiXCircle } from 'react-icons/fi'
import { FaHandSparkles } from "react-icons/fa";
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle, IoMdCreate } from "react-icons/io";
import { generatedOfferWithTotalsDoc } from '../gestioneDatabase/Docs';
import { RiInsertRowTop } from "react-icons/ri";
import { EditableProducts } from './EditableProducts';
import { GroupedPin } from './GroupedPin';
import { InfoButton } from '../frontend_components/TestButton';


/**
 * A grouped draggable pin component that displays a list of products and allows the user to edit them.
 * #offers 
 * @param {Object} props - The component props.
 * @param {Function} props.register - The function to register a new product.
 * @param {Function} props.registerTemplate - The function to register a new template.
 * @param {Array} props.nonConformities - The list of non conformities.
 * @param {Array} props.dataArray - The list of products.
 * @param {Function} props.updateDataArray - The function to update the list of products.
 * @param {Object} props.updatedOffer - The updated offer document.
 * @param {Object} props.offer - The offer document.
 * @param {Object} props.item - The item document.
 * @param {Function} props.setItem - The function to set the item document.
 * @param {Object} props.commonStyle - The common style object.
 */
export const DraggablePin = ({register, registerTemplate, nonConformities, item, priceListItem, offer, setIsEditingOffer, commonStyle, index, updatedOffer, updateDataArray, dataArray, manualAdd }) => {
    
    const [viewEdit, setViewEdit] = useState(manualAdd)
    //const [isAdding, setIsAdding] = useState(false)
    const isAdding = false
    const [viewEditProducts, setViewEditProducts] = useState(false)
    const [editDoc, setEditDoc] = useState(item)

    const editDocFunction = (doc) => {
        setEditDoc(doc)
    }
    const updatedSingleDoc = (originalDoc, editDoc) => {
      const {description, law, supplierPrice, discount, pricelistCode, unitPrice, labourHours} = editDoc
      const doc = {
        ...originalDoc, 
        //location,
        description,
        descriptionText: description?.blocks?.map?.((x)=>x?.text)?.toString(),
        law,
        supplierPrice,
        //quantity,
        discount,
        pricelistCode, 
        unitPrice
      }
     // #labourProducts
      const labourDoc = {
        ...originalDoc, 
        //location,
        description,
        descriptionText: description?.blocks?.map?.((x)=>x?.text)?.toString(),
        law,
        supplierPrice,
        //quantity,
        labourHours,
        discount,
        pricelistCode, 
        unitPrice
      }
      //if(editDoc?.isManual) return manualDoc
      if(editDoc?.labourProduct) return labourDoc
      return doc
    }
  
    const [groupProducts, setGroupProducts] = useState(!Array.isArray(dataArray) ? [] : dataArray?.filter?.((x)=>editDoc?.fieldsIds?.some?.((y)=>y == x?._id))?.map?.((obj)=>(updatedSingleDoc(obj, editDoc))))
    const productsInOfferFields = !Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!Array.isArray(groupProducts) ? false : groupProducts?.some?.((y)=>x?._id == y?._id))
    //const areOfferFieldsSameAsGroupProducts = productsInOfferFields?.every(x=>x?.hide) !== groupProducts?.every(x=>x?.hide) ? false : true
    useEffect(()=>{
     if(productsInOfferFields?.every(x=>x?.hide) !== groupProducts?.every(x=>x?.hide)){
       
       if(productsInOfferFields?.every(x=>x?.hide)) {
        console.log("ldmalkdmklas productS in offer changed and hide is true, hiding line", {productInOfferFields: productsInOfferFields})
         hideLine(true)
       }
       if(!productsInOfferFields?.every(x=>x?.hide)) {
        console.log("dpokqpkdqowpdk products in offer changed and hide is false, showing line", {productInOfferFields: productsInOfferFields})
         showLine(true)
       }
     }
    },[productsInOfferFields])

    useEffect(() => {
      const newDocs = !Array.isArray(dataArray) ? [] : dataArray?.filter?.((x)=>editDoc?.fieldsIds?.some?.((y)=>y == x?._id))?.map?.((obj)=>(updatedSingleDoc(obj, editDoc)))
      if(editDoc?.customerProductId == "da3a046a-cd5b-4580-9963-03355ba141ab"){
        console.log("groupProducts djwjdoiewdj", {groupProducts, dataArray, editDoc, newDoc: newDocs})
      }
      setGroupProducts(newDocs)
      if(editDoc?.clientOrder != newDocs[0]?.clientOrder){
        editDocFunction({...editDoc, clientOrder: newDocs[0]?.clientOrder})
      }
    },[dataArray, editDoc])

    //const groupProducts = dataArray?.filter?.(productsFilter)?.map?.((obj)=>generatedOfferWithTotalsDoc(updatedSingleDoc(obj)))
    //console.log("findProducts", groupProducts)
    const groupProductsWithTotals = !Array.isArray(groupProducts) ? [] : groupProducts?.map?.((obj)=>generatedOfferWithTotalsDoc(obj))
    //console.log("productsWithTotals", groupProductsWithTotals)
  
    
    const setContent = (data, objKey) => {
      const updatedDoc = (product, newValue, key) => {
        const docKey = () => {
          //if(key=="quantity") return "manualQuantity"
          return key
        }
        const doc = {
          ...product,
          [docKey()]:newValue[key]
        }
        return doc
  
      }
        //console.log("SET CONTENT:", data, objKey)
        editDocFunction(updatedDoc(editDoc, data, objKey))
        //updates single products
        //console.log("SET CONTENT DATA!!!", offer, updatedData, updateOfferFields(offer, updatedData))
        //console.log("SET CONTENT FIND PRODUCTS!!!", updatedData)
  
  }

  
    const updateOffer = () => {
      console.log("BEGIN OFFER UPDATE", editDoc)
  
          //updates single products
         
          const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.((y)=>!groupProducts?.some?.((x)=>x?._id == y?._id)), ...groupProducts]?.sort(sortByOrder)
          console.log("updatedDataFrom Find Products", updatedData)
               
          const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!updatedData?.some?.((y)=>x?._id == y?._id)), ...updatedData]}
          updatedOffer(updatedOfferDoc)

          const updatedDataWithTotals = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.((y)=>!groupProductsWithTotals?.some?.((x)=>x?._id == y?._id)), ...groupProductsWithTotals]?.sort(sortByOrder)
          updateDataArray(updatedDataWithTotals)

          // Instead of toggling viewEdit, just set it to false to avoid unnecessary refetches
          setViewEdit(false)
    }
  
    const deleteLine = () => {
       
       const deleteFn =()=> {
        
        setIsEditingOffer(true)
        //update data array
        
        const updatedDataArray = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.((y)=>!groupProductsWithTotals?.some?.((x)=>x?._id == y?._id))]?.sort(sortByOrder)
               updateDataArray(updatedDataArray)
        const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!dataArray?.some?.((y)=>x?._id == y?._id)), ...updatedDataArray]}
        updatedOffer(updatedOfferDoc)
  
  
        console.log(
          "ITEM", item,
          "New Offer Doc", updatedOfferDoc, 
          "DATA ARRAY", dataArray, 
          "New Array", updatedDataArray)
       }
      alertDelete(deleteFn)
      //deleteFn()
    }
  
    const hideLine = (bypassOfferUpdate) => {
      //setIsEditingOffer(true)
      const hiddenDoc = (item) => ({...item, clientOrder: undefined, hide: true})
      
      //updates single products
      const findProducts = !Array.isArray(groupProducts) ? [] : groupProducts?.map?.((obj)=>hiddenDoc(obj))
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.((y)=>!findProducts?.some?.((x)=>x?._id == y?._id)), ...findProducts]?.sort(sortByOrder)
      updateDataArray(updatedData)
  
      //updates grouped draggable array
      editDocFunction(hiddenDoc(editDoc))
  
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!dataArray?.some?.((y)=>x?._id == y?._id)), ...updatedData]}
      if(!bypassOfferUpdate) updatedOffer(updatedOfferDoc)
      console.log("HIDE LINE", !Array.isArray(updatedOfferDoc?.updatedData) ? [] : updatedOfferDoc?.updatedData?.filter?.((x)=>x?.hide))
    }
  
    const showLine = (bypassOfferUpdate) => {
      //setIsEditingOffer(true)
      const showDoc = (item) => ({...item, hide: false})
      
      //updates single products
      const findProducts = groupProducts?.map?.((obj)=>showDoc(obj))
      const updatedData = [...!Array?.isArray(dataArray) ? [] : dataArray?.filter?.((y)=>!findProducts?.some?.((x)=>x?._id == y?._id)), ...findProducts]?.sort(sortByOrder)
      updateDataArray(updatedData)
  
      //updates grouped draggable array
      editDocFunction(showDoc(editDoc))
  
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!Array.isArray(dataArray) ? false : !dataArray?.some?.((y)=>x?._id == y?._id)), ...updatedData]}
      if(!bypassOfferUpdate) updatedOffer(updatedOfferDoc)
      //console.log("SHOW LINE", updatedOfferDoc?.updatedData?.filter?.((x)=>x?.hide))
    }
  
    const editProducts = () => {
      setViewEditProducts(!viewEditProducts)
     
      //console.log("EDIT PRODUCTS", !viewEditProducts)
  
    }
    const toggleViewEdit = () => {
      setViewEdit(!viewEdit)
      console.log("CONTENT", editDoc)
    }
  
   
  
     const allProductsAreHidden = !Array.isArray(groupProducts) ? false : groupProducts?.every?.((x)=>x?.hide)
     const someProductsHidden = !Array.isArray(groupProducts) ? false : groupProducts?.some?.((x)=>x?.hide)
     const someProductsAdded = !Array.isArray(groupProducts) ? false : groupProducts?.some?.((x)=>x?.addedLocation)
     const someProductsEdited = !Array.isArray(groupProducts) ? false : groupProducts?.some?.((x)=>x?.edited)


     const infoHtml = () => {
      const htmlData = `
        <div style="text-align: center; border: 1px solid lightgrey; border-radius: 10px; padding: 20px;">
            ${htmlInfoLine({value: item?.customerProduct, title: "PRODOTTO INTERNO"})}
            ${htmlInfoLine({value: item?.nonConformity, title: "NON CONFORMITA'"})}
        </div>
        `
       return htmlData
     }  
     const consoleData = {
       groupProducts,
       item,
       priceListItem,
       offer,

    }
  
     const iconsMarginLeft = "24px"
  
    return (
  
          <>          
            <GroupedPin 
              groupProducts={groupProducts}
              allHidden = {allProductsAreHidden} 
              manualAdd={manualAdd} 
              products={dataArray} 
              offer={offer} 
              item={editDoc} 
              setItem={setContent} 
              index={index} 
              commonStyle={commonStyle} 
              edit={viewEdit}
              priceListItem={priceListItem}
              register={register}
            />
            <VisDiv style={{display:"flex", justifyContent:"left", marginTop:"-30px", backgroundColor:"white", width: "380px", padding:"3px", borderRadius:"10px"}}> 
                <div  style={{cursor:"pointer" }} >
                    <VisDiv rules={[false]}>
                      <button onClick={(e)=>testFunction(e)}>testLine</button>
                    </VisDiv>
                    
                  
                    <VisDiv rules={[!viewEdit, !isAdding]}>
                      <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={()=>toggleViewEdit()}>
                          <FiEdit             
                          size={15}
                          color={"white"}/>
                      </button>
                  </VisDiv>
                  
                  <VisDiv rules={[viewEdit, !isAdding]} style={{display:"flex"}}>
        
                      <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={()=>updateOffer()}>
                          <FiSave            
                          size={15}
                          color={"white"}/>
                      </button>
                      <button type='button' className='round-back-button' style={{backgroundColor:"red", marginLeft:"10px"}} onClick={()=>setViewEdit(false)}>
                        <FiXCircle fontSize={30}   
                            size={15}
                            color={"white"}/>
                      </button>
                  </VisDiv>
                </div>
                {/*<VisDiv rules={[false]} style={{color:"darkBlue", cursor:"pointer", marginLeft: iconsMarginLeft}} >
                    <VisDiv className='round-back-button' style={{backgroundColor:"white"}} rules={[!viewEdit, !isAdding]} onClick={(e) => {toggleIsAdding()}}> 
                      <IoIosAddCircleOutline fontSize={30} />
                    </VisDiv>
                    <VisDiv className='round-back-button' rules={[!viewEdit, isAdding]} onClick={(e) => {toggleIsAdding()}}>
                      <IoMdRemoveCircle fontSize={30} />
                    </VisDiv>
                </VisDiv> */}
                <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft: iconsMarginLeft}}>
                    <VisDiv className='round-back-button' style={{backgroundColor:"grey"}} rules={[!isAdding, !viewEdit, allProductsAreHidden]} onClick={(e) => {showLine()}}>
                      <IoIosEyeOff fontSize={20} color='white'/>
                    </VisDiv>
                    <VisDiv className='round-back-button' style={{backgroundColor:"green"}} rules={[!isAdding, !viewEdit, !allProductsAreHidden]} onClick={(e) => {hideLine()}}>
                      <IoIosEye fontSize={20} color='white' />
                    </VisDiv>
                </VisDiv>
                {/*<VisDiv rules={[false]} style={{color:"darkRed", cursor:"pointer", marginLeft: iconsMarginLeft}} >
                    <VisDiv className='round-back-button' style={{backgroundColor:"red"}} rules={[!isAdding, !viewEdit]} onClick={(e) => {deleteLine()}}> 
                      <MdDelete fontSize={20} color='white' />
                    </VisDiv>
                </VisDiv> */}
                <VisDiv style={{color:"darkRed", cursor:"pointer", marginLeft: iconsMarginLeft}} >
                    <VisDiv className='round-back-button' style={{backgroundColor:"blue"}} rules={[!isAdding, !viewEdit, !viewEditProducts]} onClick={(e) => {editProducts()}}> 
                      <IoIosArrowDropdownCircle fontSize={20} color='white' />
                    </VisDiv>
                    <VisDiv className='round-back-button' style={{backgroundColor:"blue"}} rules={[!isAdding, !viewEdit,viewEditProducts ]} onClick={(e) => {editProducts()}}> 
                      <IoIosArrowDropupCircle fontSize={20} color='white' />
                    </VisDiv>
                </VisDiv>
                <VisDiv rules={[editDoc?.isManual]} style={{backgroundColor:"white", marginLeft: iconsMarginLeft}}>
                    <FaHandSparkles fontSize={30} color='grey' />             
                </VisDiv>
                <VisDiv rules={[editDoc?.clientOrder]} style={{backgroundColor:"white", marginLeft: iconsMarginLeft}}>
                    <IoMdCart fontSize={25} color='grey' />             
                </VisDiv>
                <VisDiv rules={[someProductsHidden]} style={{backgroundColor:"white", marginLeft: iconsMarginLeft}}>
                   <IoIosEyeOff fontSize={25} color='grey' />
                </VisDiv>
                <VisDiv style={{color:"darkBlue", marginLeft: iconsMarginLeft}} rules={[someProductsAdded, !editDoc?.isManual]}>
                  <RiInsertRowTop fontSize={25} color='grey'/>
                </VisDiv>
                <VisDiv style={{color:"darkBlue", marginLeft: iconsMarginLeft}} rules={[someProductsEdited]}>
                  <IoMdCreate fontSize={25} color='grey' />
                </VisDiv>
                <VisDiv style={{color:"darkBlue", marginLeft: iconsMarginLeft}} rules={[]}>
                  <InfoButton buttonId={"olmdlqwmxdlkamwdx"} consoleData={consoleData} html={infoHtml()} />
                </VisDiv>

            </VisDiv>
             <EditableProducts 
                groupProducts={groupProducts}
                register={register} 
                registerTemplate={registerTemplate}
                nonConformities={nonConformities}
                dataArray={dataArray} 
                updateDataArray={updateDataArray} 
                updatedOffer={updatedOffer} 
                offer={offer} 
                isVisible={viewEditProducts} 
                item={editDoc} 
                setItem={editDocFunction} 
                commonStyle={commonStyle}/> 
          </>
    );
  }

/**
 * Updates the offerFields array in the given offer document.
 * It filters out the offerFields that have the same _id as the newFields and then concatenates the newFields.
 * @param {Object} offer - The offer document to be updated
 * @param {Array<Object>} newFields - The new fields to be added to the offerFields array
 * @return {Object} The updated offer document with the new offerFields array
 */
  export  const updateOfferFields = (offer, newFields) => {
  
    const doc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>!newFields?.some?.((y)=>x?._id == y?._id)), ...newFields]}
    return doc
  }
